import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import type { ProductBreakthroughItemsProps } from './ProductBreakthroughItems';
import ProductBreakthroughItems from './ProductBreakthroughItems';

const ProductBreakthrough = ({
  shopButton,
}: ProductBreakthroughItemsProps): JSX.Element => {
  const t = useTranslations();

  return (
    <section
      style={{
        background:
          'linear-gradient(72.18deg, #000000 29.6%, #0C1017 48.75%, #11161E 57.55%, #131820 67.78%, #141A22 75.86%, #151B23 83.24%, #151A23 95.85%)',
      }}
      className="py-32 text-white"
      data-cy="product-breakthrough"
    >
      <LayoutGrid rowGap={32}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyV3
            color="inherit"
            variant="h2"
            Element="h2"
            align="center"
          >
            {t.rich('pdp_horizon_breakthrough_title', {
              i(chunks) {
                return <em className="font-serif italic">{chunks}</em>;
              },
            })}
          </TypographyV3>

          <TypographyV3
            color="inherit"
            align="center"
            className="mx-auto mt-6 max-w-xl"
          >
            {t.rich('pdp_horizon_breakthrough_subtitle')}
          </TypographyV3>
        </GridItem>

        <ProductBreakthroughItems shopButton={shopButton} />
      </LayoutGrid>
    </section>
  );
};

export default ProductBreakthrough;
